import { createContext } from 'react';

interface AccountSwitcherContextValue {
  isSwitchingAccounts: boolean;
  setIsSwitchingAccounts: (state: boolean) => void;
}

export const AccountSwitcherContext = createContext<AccountSwitcherContextValue>({
  isSwitchingAccounts: false,
  setIsSwitchingAccounts: () => {},
});
